/**
 * Unified function to wait for monitor status update.
 *
 * @param id - Monitor ID
 * @param afterTimestamp - Optional timestamp to wait for updates after.
 *                        If not provided, waits for first check (status != no_data).
 * @returns Monitor data if updated, null if timeout
 */
export async function waitForMonitorStatus(id: string, afterTimestamp?: number) {
  let url = `/web_api/monitors/${id}/wait_for_status`;

  if (afterTimestamp !== undefined) {
    // Ensure afterTimestamp is a valid integer
    const timestamp = Math.floor(afterTimestamp);
    url += `?after_timestamp=${timestamp}`;
  }

  try {
    const resp = await fetch(url);
    if (resp.status === 200) {
      return await resp.json();
    } else if (resp.status === 304) {
      // No status update detected within timeout
      return null;
    } else {
      console.error("waitForMonitorStatus error:", resp.status, await resp.text());
      return null;
    }
  } catch (error) {
    console.error("waitForMonitorStatus network error:", error);
    return null;
  }
}

// Legacy functions for backward compatibility
export async function waitForMonitorFirstCheck(id: string) {
  return waitForMonitorStatus(id);
}

export async function waitForMonitorUpdate(id: string, afterTimestamp: number) {
  return waitForMonitorStatus(id, afterTimestamp);
}
